<template>
  <div class="menu">
    <div v-for="(item,index) in filterRoute" :key="index" :class="(item.path&&route.indexOf(item.path)!==-1)||(!item.path&&route.indexOf(item.redirect)!==-1)?'menuName checkItem':'menuName defaultItem'" @click.prevent="showList(index,$event)">
      <span v-if="item.meta">{{item.meta.title}}</span>
      <router-link class="link" v-else :to="item.path?item.path:'/index'">
        {{item.children[0].meta.title==='首页'?'我的工作台':item.children[0].meta.title}}
      </router-link>
      <img v-if="item.meta" src="../../assets/images/list/icon.png" alt="">
      <transition name="fade">
        <ul class="menuList" v-if="item.meta && (checkedInd === index && isShowList)">
          <li v-for="(list,ind) in item.children" :key="index+ind">
            <router-link class="link" :to="item.path==='//accident'?list.path:item.path+'/'+list.path">
              {{list.meta.title}}
            </router-link>
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {isExternal} from '@/utils/validate';
export default {
  data() {
    return {
      checkedInd: '',
      isShowList: false
    }
  },
  computed: {
      ...mapGetters(['sidebarRouters']),
      filterRoute() {
        const list = this.sidebarRouters.filter(item => {
          return !item.hidden && item.component && item.children && item.path.indexOf('accident')==-1
        })
        return list
      },
      route() {
        return this.$route.path
      }
  },
  created() {
    console.log(this.filterRoute);
  },
  mounted(){
    // 点击空白处隐藏导航栏子菜单
    document.addEventListener('mouseup',(e) =>{
      let self = document.getElementsByClassName('menu')[0]
      if(self && !self.contains(e.target) && this.isShowList) {
        this.isShowList = false
      }
    })
  },
  methods: {
    showList(ind,event) {
      if (!ind) {
        this.isShowList = false;
        this.checkedInd = ind;
      }else {
         if (event.target.tagName === 'LI') {
          return
        }
        if (this.checkedInd && ind!==this.checkedInd) {
          this.isShowList = true;
        } else {
          this.isShowList = !this.isShowList;
        }
        this.checkedInd = ind;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu {
  display: -webkit-flex;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  .menuName {
    position: relative;
    width: 160px;
    height: 48px;
    margin-right: 20px;
    text-align: center;
    line-height: 48px;
    color: #B1E3FF;
    font-size: 18px;
    letter-spacing: 1px;
    cursor: pointer;
    .link {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      position: absolute;
      right: 13px;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    .menuList {
      position: absolute;
      left: 0;
      top: 48px;
      width: 160px;
      z-index: 9999;
      padding: 0;
      margin: 0;
      text-align: center;
      background-color: #0B2756;
      border: 1px solid #0084FF;
      border-top: none;
      li {
        list-style: none;
        height: 45px;
        line-height: 45px;
        border-top: 1px solid #0084FF;
        &:hover {
          color: rgba(14, 189, 53, 1);
        }
      }
    }
  }
  .defaultItem {
    background: url("../../assets/images/list/tab2.png") no-repeat;
    background-size: 100% 100%;
  }
  .checkItem {
    background: url("../../assets/images/list/tab1.png") no-repeat;
    background-size: 100% 100%;
  }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity .7s;
}
.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */
{
    opacity: 0;
}
</style>